var _ellipse, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.1077,
    cy: 12,
    rx: 6.05432,
    ry: 6,
    fill: "#F8F9FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1077 0L14.7293 4.5H9.48607L12.1077 0Z",
    fill: "#F8F9FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1077 24L14.7293 19.5H9.48607L12.1077 24Z",
    fill: "#F8F9FA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.62125 6.00001L6.86444 6.00001L4.24284 10.5L1.62125 6.00001Z",
    fill: "#F8F9FA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5941 18L19.9725 13.5L17.3509 18L22.5941 18Z",
    fill: "#F8F9FA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.62125 18L4.24284 13.5L6.86444 18L1.62125 18Z",
    fill: "#F8F9FA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5941 6.00001L17.3509 6.00001L19.9725 10.5L22.5941 6.00001Z",
    fill: "#F8F9FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDayIcon);
export default __webpack_public_path__ + "static/media/day-icon.a79a879cf35ef6aba8a0822703ddf8a8.svg";
export { ForwardRef as ReactComponent };